import { z } from 'zod'

// エージェント用 API に、どの組織として要求するかを送るヘッダー。
// BE は、この組織 ID を GraphQL と同じ getCurrentOrganization で、利用者が所属しているかを確かめてから使う
export const ORGANIZATION_ID_HEADER = 'x-organization-id'

// パスの値の型は、express の Request の params（文字列の添字を持つ型）に渡せるよう、interface ではなく Record で書く。
// interface には添字がないので、Request<SessionPathParams> の型検査が通らない

// /api/agent/gateway/sessions/{agentSessionId} の下のパスの値。agentSessionId は storage が振ったセッションの ID
export type SessionPathParams = Record<'agentSessionId', string>

// /api/agent/gateway/sessions/{agentSessionId}/turns/{turnId} の下のパスの値。turnId は BE が run で振ったターンの ID
export type TurnPathParams = SessionPathParams & Record<'turnId', string>

// POST /api/agent/gateway/sessions/{agentSessionId}/turns/{turnId}/approvals/{approvalId} のパスの値。
// approvalId は runtime が run の SSE の approval_request で送った承認の ID
export type ApprovalPathParams = TurnPathParams & Record<'approvalId', string>

// 小文字の UUIDv7。storage と runtime が、パスで指す ID をこの形に限る
// （salescore-agent-storage の request-fields.ts、salescore-agent-runtime の invocation.ts と同じ形）
const uuidV7Schema = z.string().regex(/^[\da-f]{8}-[\da-f]{4}-7[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/v)

// パスで指すセッションの ID。storage が振る
export const agentSessionIdSchema = uuidV7Schema

// パスで指すターンの ID。BE が run で振る
export const turnIdSchema = uuidV7Schema

// パスで指す承認の ID。runtime（ランナー）が run の SSE の approval_request で振る
export const approvalIdSchema = uuidV7Schema
